export default __webpack_public_path__ + "static/media/Cardinals.bf30d088.png";